import styled from "@emotion/styled";

export const Wrapper = styled.section`
  > * + * {
    margin-block-start: 16px;
  }
`;
